module.exports = __webpack_public_path__ + "src/assets/img/meetingList_austin1.572ce300.jpg";